import type { DomainStatus, Site } from "~/api/Api";

/**
 * True when the AI Visibility Engine is enabled AND every configured step in
 * the delegated-domain status is green. Mirrors the green vs red engine icon
 * shown on the sites dashboard (see SiteCard.tsx).
 *
 * When healthy, bots and LLMs are served prerendered content directly, so
 * per-page visibility/performance metrics become "engine-handled" — UI should
 * surface a reassuring indicator instead of the raw bars.
 */
export function isEngineHealthy(
  site: Pick<Site, "prerendering" | "delegated_domain"> | null | undefined,
): boolean {
  if (!site?.prerendering) return false;

  const status = site.delegated_domain?.status;
  const hasFailedStep = (
    Object.keys(status || {}) as (keyof DomainStatus)[]
  ).some((k) => status?.[k] === false);

  return !hasFailedStep;
}
